import React from 'react';

import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikIconPicker from 'src/components/formik/FormikIconPicker';
import useGetRequest from 'src/hooks/useGetRequest';
import useModal from 'src/components/Modal/useModal';
import { Step } from 'src/types';
import ActionTypeMiniCard from 'src/components/miniCards/ActionTypeMiniCard';

import TaskTemplateBuilderModal from './TaskTemplateBuilderModal';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE } from '../../../../constants/constants';

interface Props {
  step: Step,
  onSuccess: () => void,
}

const TaskTemplateForm = ({
  step, onSuccess,
}: Props) => {
  const { result: roles } = useGetRequest({
    url: `/automatic/workflows/${step.workflowId}/roles/`,
    initialResult: [],
  });
  const {
    isOpen, openModal, closeModal
  } = useModal();

  const fieldsConfig = [
    {
      name: 'title',
      component: () => (
        <FormikInput
          fullWidth
          label="Task title"
          name="title"
        />
      ),
    },
    {
      name: 'assignedToRoleId',
      component: () => (
        <FormikSelect
          fullWidth
          label="Assigned to"
          name="assignedToRoleId"
          options={roles.map((role: any) => ({
            value: role.id,
            label: role.name
          }))}
        />
      ),
    },
    // {
    //   name: 'description',
    //   component: () => (
    //     <FormikQuillEditor
    //       label="Description"
    //       name="description"
    //       workflowId={step.workflowId}
    //     />
    //   ),
    // },
    {
      name: 'icon',
      component: () => <FormikIconPicker name="icon" />,
      gridProps: { xs: 12, md: 6 },
    },
    {
      component: () => (
        <ActionTypeMiniCard
          // @ts-ignore - step will have an action
          actionType={EVENT_ATTRIBUTES_BY_EVENT_TYPE[step.action.actionType]}
          onClick={() => openModal()}
        />
      ),
    },
  ];

  return (
    <>
      {
        isOpen && (
          <TaskTemplateBuilderModal onClose={closeModal} step={step} />
        )
      }
      <CRUDConfigForm
        url={`/automatic/workflows/${step.workflowId}/task-templates/`}
        // @ts-ignore - task template will exist here
        objectId={step.action.taskTemplate.id}
        fieldsConfig={fieldsConfig}
        autoSave
        onSuccess={onSuccess}
      />
    </>
  );
};

export default TaskTemplateForm;
